// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jv-0";
export var assigneeDetails = "_jv-1";
export var assigneeInfo = "_jv-2";
export var dropdownContainer = "_jv-4";
export var dropdownImage = "_jv-5";
export var editAssigneeInfo = "_jv-3";
export var editAssigneeModalContainer = "_jv-6";
export var hidden = "_jv-8";
export var input = "_jv-7";